import { Suspense, useState } from 'react'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Loader2, MailPlus } from 'lucide-react'
import { profile } from '@/lib/queries/profiles'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import { AdminUsersList, BulkInviteDialog } from '@/features/admin'

export const Route = createFileRoute('/_authenticated/admin/users')({
  loader: ({ context }) => {
    context.queryClient.query({
      ...profile.findManyForAdmin(),
      staleTime: 'static',
    })
  },
  component: AdminUsersPage,
})

function AdminUsersPage() {
  const { data: users } = useSuspenseQuery(profile.findManyForAdmin())
  const [bulkInviteOpen, setBulkInviteOpen] = useState(false)

  return (
    <div className='w-full space-y-2'>
      <div className='flex flex-wrap items-start justify-between gap-4'>
        <div>
          <h2 className='font-heading text-xl'>Users</h2>
          <p className='text-muted-foreground text-sm'>Manage platform users</p>
        </div>
        <Button onClick={() => setBulkInviteOpen(true)}>
          <MailPlus /> Invite users
        </Button>
      </div>

      <AdminUsersList data={users} />

      {bulkInviteOpen && (
        <Suspense
          fallback={
            <Dialog open>
              <DialogContent className='flex justify-center py-16'>
                <DialogTitle className='sr-only'>Invite users</DialogTitle>
                <Loader2 className='text-muted-foreground h-6 w-6 animate-spin' />
              </DialogContent>
            </Dialog>
          }
        >
          <BulkInviteDialog
            open={bulkInviteOpen}
            onOpenChange={setBulkInviteOpen}
          />
        </Suspense>
      )}
    </div>
  )
}
